import React, { HTMLAttributes } from 'react'
import theme from '../../../styles/theme'
import * as S from './styles'

export type SupportTextProps = {
  color?: keyof typeof theme.ds.colors
  weight?: keyof typeof theme.ds.typography.weight
  lineHeight?: keyof typeof theme.ds.typography.lineHeight
  size?: keyof typeof theme.ds.typography.size
  capitalize?: boolean
  as?: 'p' | 'span' | 'div' | 'strong' | 'i' | 'b' | 'h6' | 'small'
} & HTMLAttributes<HTMLParagraphElement>

const SupportTextNew = ({
  color = 'neutral500',
  weight = 'normal',
  size = 'small',
  capitalize = false,
  lineHeight = 'medium',
  children,
  as = 'p',
  ...props
}: SupportTextProps) => (
  <S.Wrapper
    color={color}
    weight={weight}
    size={size}
    capitalize={capitalize}
    lineHeight={lineHeight}
    as={as}
    {...props}
  >
    {children}
  </S.Wrapper>
)

export default SupportTextNew
